import React from 'react';

import ForgotPasswordRoutes from './routes';

const ForgotPassword = () => <ForgotPasswordRoutes />;

export default ForgotPassword;
